import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/MyPersonalTodoTask.css";
import calendar from "../../assets/icons/calendar.svg";
import AppDatePicker from "../Common/AppDatePicker";
import moment from "moment";

import {
  AddPersonalTask,
  FetchPersonalTask,
  UpdateIsCheckPersonalTask,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import useClickOutside from "../../utils/hooks/useClickOutside";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function MyPersonalTodoTask5() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const calendar_Popup_Ref = useRef(null);
  const filter_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");

  const addPersonalTaskRes = useSelector(
    (state) => state.user.addPersonalTaskRes
  );

  const fetchPersonalTaskRes = useSelector(
    (state) => state.user.fetchPersonalTaskRes
  );

  const updateIsCheckPersonalTaskRes = useSelector(
    (state) => state.user.updateIsCheckPersonalTaskRes
  );

  // state variables start 👇
  // const [personalTaskData, setPersonalTaskData] = useState([
  //   {
  //     checked: false,
  //     firstName: "",
  //     taskDate: null,
  //     calendarIsOpen: false,
  //   },
  // ]);

  const [personalTaskData, setPersonalTaskData] = useState([]);
  const [staticTaskName, setStaticTaskName] = useState("");
  const [staticDate, setStaticDate] = useState(null);
  const [staticCalendarOpen, setStaticCalendarOpen] = useState(false);
  const [fetchTransFaceBookList, setFetchTransFaceBookList] = useState({});
  const t = (key) => fetchTransFaceBookList?.[key] || "";
  const [taskIDRes, setTaskIDRes] = useState("");

  useEffect(() => {
    fetchScreenTranslations("TeamConnect").then((res) => {
      setFetchTransFaceBookList(res);
    });
  }, []);

  useEffect(() => {
    dispatch(FetchPersonalTask());
  }, [updateIsCheckPersonalTaskRes]);

  useEffect(() => {
    if (addPersonalTaskRes.status === true) {
      setTaskIDRes(addPersonalTaskRes?.data?.taskid);
    }
  }, [addPersonalTaskRes]);

  useEffect(() => {
    if (fetchPersonalTaskRes.status === true) {
      // start item pushing...
      let TaskArray = [];
      fetchPersonalTaskRes?.data
        .filter((x) => x.taskname && x.taskname.trim() !== "")
        // .sort((a, b) => a.taskname.localeCompare(b.taskname))
        .map((item) => {
          return TaskArray.push({
            // checked: false,
            checked: item.ischeck ?? false, // default false if checked is undefined
            taskID: item.taskid,
            firstName: item.taskname,
            taskDate: new Date(item.duedate),
            calendarIsOpen: false,
          });
        });

      TaskArray.sort((a, b) => a.checked - b.checked);
      setPersonalTaskData(TaskArray);
    }
  }, [fetchPersonalTaskRes]);

  const handleInputChange = (index, field, value) => {
    const newItems = [...personalTaskData];
    newItems[index][field] = value;
    // setPersonalTaskData(newItems);

    console.log("asc56 item,", newItems);

    // Close all other calendars when one is opened.
    if (field === "calendarIsOpen" && value === true) {
      newItems.forEach((item, i) => {
        if (i !== index) {
          item.calendarIsOpen = false;
        }
      });
    }

    let ascTaskid = newItems[index].taskID;
    let ascTaskChecked = newItems[index].checked;
    let ascTaskDueDateTime = newItems[index].taskDate;

    if (ascTaskChecked || ascTaskDueDateTime) {
      dispatch(
        UpdateIsCheckPersonalTask(
          ascTaskDueDateTime,
          ascTaskid || taskIDRes,
          ascTaskChecked
        )
      );
    }

    // set checked items in bottom of list 👇
    newItems.sort((a, b) => a.checked - b.checked);
    setPersonalTaskData(newItems);
  };

  // for Date Label start.
  const formatDateLabel = (date) => {
    if (!date) return "";

    const dateMoment = moment(date);
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "days").startOf("day");
    const tomorrow = moment().add(1, "days").startOf("day");

    // Check if the date is today, yesterday, or tomorrow, and return the appropriate label
    if (dateMoment.isSame(today, "day")) {
      return "Today";
    } else if (dateMoment.isSame(yesterday, "day")) {
      return "Yesterday";
    } else if (dateMoment.isSame(tomorrow, "day")) {
      return "Tomorrow";
    } else {
      return dateMoment.format("MMM DD"); // Default format for other dates
    }
  };
  // for Date Label end.

  // for Date Label start.
  const formatDateLabel2 = (date) => {
    const today = new Date();
    const dayDifference = Math.floor((date - today) / (1000 * 60 * 60 * 24));

    switch (dayDifference) {
      case 0:
        return "Today";
      case -1:
        return "Yesterday";
      case 1:
        return "Tomorrow";
      default:
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
    }
  };
  // for Date Label end.

  // Focus the Add new task input field.
  // useEffect(() => {
  //   document.getElementById("asc_Todo").focus();
  // }, [staticTaskName]);

  // Call the custom hook to handle click outside 👇
  useClickOutside(calendar_Popup_Ref, () => {
    // setProjectShowOptions(false);
    // setArrowOptionsRotate(false);
  });

  // set here localIndex when we run handle Next index will update👇
  // {personalTaskData
  //   .slice(sliceIndex, sliceIndex + itemsPerPage)
  //   .map((item, localIndex) => {
  //      const index = localIndex + sliceIndex; // Adjusted index
  //     return (
  //       <div className="d-flex gap-1 taskTodoInputDiv" key={index}>

  return (
    <div className="">
      <p className="pt-3 ps-3 todoHead">
        {/* My Personal ToDo Tasks */}
        {t("My Personal ToDo Tasks")}
      </p>

      <div className="mypersonalTodo">
        {personalTaskData.map((item, index) => {
          console.log("asc56", personalTaskData.length - 1);
          return (
            <div
              className="d-flex gap-3 taskTodoInputDiv"
              key={index}
              title={item.firstName.length > 10 && item.firstName}
            >
              <input
                type="checkbox"
                checked={item.checked}
                className="form-check-input pointer companyRadio ms-"
                onChange={() => {
                  handleInputChange(index, "checked", !item.checked);
                }}
              />

              <input
                type="text"
                // placeholder="Add a Task"
                placeholder={t("Add a Task")}
                className="taskTodoInput"
                style={{
                  width: "60%",
                  textDecoration: item.checked ? "line-through" : "none",
                  // pointerEvents:
                  //   index === personalTaskData.length - 1 ? "" : "none",
                  // pointerEvents: item.checked ? "none" : "",
                  pointerEvents: "none",
                  // for 3 dots 👇
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                // title={item.firstName.length > 10 && item.firstName}
                value={item.firstName}
                onChange={(e) =>
                  handleInputChange(index, "firstName", e.target.value)
                }
              />

              <div className="d-flex align-items-center gap-2 pointer">
                <label
                  id="report_calender_DNone"
                  style={{
                    // display: "flex",
                    // width: "94%",
                    position: "relative",
                    top: "10px",
                  }}
                >
                  {item.taskDate === null ? (
                    <img
                      className="calendarIcon pointer"
                      // onClick={() => toggleCalendar(index)}
                      onClick={() => {
                        handleInputChange(
                          index,
                          "calendarIsOpen",
                          !item.calendarIsOpen
                        );
                      }}
                      src={calendar}
                      alt=""
                    />
                  ) : (
                    <p
                      className={
                        formatDateLabel(item.taskDate) === "Today" ||
                        formatDateLabel(item.taskDate) === "Yesterday" ||
                        formatDateLabel(item.taskDate) === "Tomorrow"
                          ? "mb-0 pointer dateInLIstInRed"
                          : "mb-0 pointer dateInLIst"
                      }
                      // onClick={() => toggleCalendar(index)}
                      onClick={() => {
                        handleInputChange(
                          index,
                          "calendarIsOpen",
                          !item.calendarIsOpen
                        );
                      }}
                    >
                      {formatDateLabel(item.taskDate)}
                    </p>
                  )}

                  <AppDatePicker
                    open={item.calendarIsOpen}
                    selected={item.taskDate}
                    onChange={(val) => {
                      // setTaskDate(val);
                      // setCalendarIsOpen(false);
                      handleInputChange(index, "taskDate", val);
                      // toggleCalendar(index);
                      // handleInputChange(index, "calendarOpen", !item.calendarOpen);
                      handleInputChange(
                        index,
                        "calendarIsOpen",
                        !item.calendarIsOpen
                      );
                    }}
                    onSelect={(d, event) => {
                      // setDateError(false);
                      event.preventDefault();
                    }}
                    // isError={dateError}
                    // error={setDateError}
                    dateFormat="dd/MM/yyyy"
                  />
                </label>

                {/* <p>{formatDateLabel(item.taskDate)}</p> */}

                <p
                  className="fw-bold text-success mb-0  d-none"
                  onClick={() => {
                    if (item.firstName.trim()) {
                      dispatch(AddPersonalTask(item.firstName, item.taskDate));
                    }
                  }}
                >
                  ↻
                </p>

                <p
                  className="fw-bold text-danger mb-0  d-none"
                  onClick={() => {
                    let data = [...personalTaskData];
                    data.splice(index, 1);
                    setPersonalTaskData(data);
                  }}
                >
                  x
                </p>

                {/* {index === personalTaskData.length - 1 &&
                item.firstName !== "" && (
                  <div>
                    <p>✔</p>
                  </div>
                )} */}

                {/* {index !== personalTaskData.length - 1 && (
                <div>
                  <p>x</p>
                </div>
              )} */}
              </div>
            </div>
          );
        })}

        {/* static Add Task fields start */}
        <div
          className="d-flex gap-2 p-3 mb-2"
          style={{ background: "#fafafa" }}
        >
          <input
            id="asc_Todo"
            type="text"
            value={staticTaskName}
            // placeholder="Add a Task"
            placeholder={t("Add a Task")}
            className="taskTodoInput ps-4"
            style={{
              width: "65%",
            }}
            onChange={(e) => {
              setStaticTaskName(e.target.value);
            }}
          />

          <div className="d-flex align-items-center gap-2 fw-bold pointer">
            <label
              id="report_calender_DNone"
              style={
                {
                  // display: "flex",
                  // width: "94%",
                  // position: "relative",
                  // top: "10px",
                }
              }
            >
              {staticDate === null ? (
                <img
                  className="calendarIcon pointer"
                  onClick={() => setStaticCalendarOpen(!staticCalendarOpen)}
                  src={calendar}
                  alt=""
                />
              ) : (
                <p
                  className={
                    formatDateLabel(staticDate) === "Today" ||
                    formatDateLabel(staticDate) === "Yesterday" ||
                    formatDateLabel(staticDate) === "Tomorrow"
                      ? "mb-0 pointer dateInLIstInRed"
                      : "mb-0 pointer dateInLIst"
                  }
                  style={{ position: "relative", top: "10px" }}
                  onClick={() => setStaticCalendarOpen(!staticCalendarOpen)}
                >
                  {formatDateLabel(staticDate)}
                </p>
              )}
              <AppDatePicker
                open={staticCalendarOpen}
                selected={staticDate}
                onChange={(date) => {
                  setStaticDate(date);
                  setStaticCalendarOpen(false);
                }}
                dateFormat="dd/MM/yyyy"
              />
            </label>
          </div>

          {staticTaskName !== "" && staticDate !== null && (
            <>
              <p
                className="mb-0 mt-1 pointer"
                style={{ color: "#2ae92a", fontSize: "20px" }}
                onClick={() => {
                  if (staticTaskName.trim()) {
                    // dispatch(AddPersonalTask(staticTaskName, staticDate));
                    dispatch(
                      AddPersonalTask(
                        staticTaskName,
                        moment(staticDate).add(1, "days")
                      )
                    );
                    setStaticTaskName("");
                    setStaticDate(null);

                    // setTimeout(() => {
                    //   dispatch(FetchPersonalTask());
                    // }, 1000);

                    // or we can do it with push 👇
                    let arr = [...personalTaskData];
                    arr.unshift({
                      checked: false,
                      firstName: staticTaskName,
                      taskDate: staticDate,
                      calendarIsOpen: false,
                    });
                    setPersonalTaskData(arr);
                  }
                }}
              >
                ✓
              </p>

              <p
                className="mb-0 pointer"
                style={{ color: "red", fontSize: "20px" }}
                onClick={() => {
                  setStaticTaskName("");
                  setStaticDate(null);
                }}
              >
                x
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyPersonalTodoTask5;
